module.exports = __webpack_public_path__ + "img/01.52512463.jpg";